var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9303 28.5152C15.1953 29.2502 14.0103 29.2502 13.2753 28.5152L0.810259 16.0502C0.225258 15.4652 0.225258 14.5202 0.810259 13.9352L13.2753 1.4702C14.0103 0.735195 15.1953 0.735195 15.9303 1.4702C16.6653 2.2052 16.6653 3.3902 15.9303 4.1252L5.07026 15.0002L15.9453 25.8752C16.6653 26.5952 16.6653 27.7952 15.9303 28.5152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeftArrow);
export default __webpack_public_path__ + "static/media/carouselLeftArrow.a8ec8866cb9ac4d15d0eac4aa90d84ae.svg";
export { ForwardRef as ReactComponent };